import { useState } from 'react';
import { Formik, Form } from 'formik';
import { request } from '../../../functions/apiRequestHelper';
// import { gtmPush } from '../../../functions/gtm';
import DealerByPostcodeModule from '../../../components/DealerByPostcodeModule';
import Button from '../../../audi-ui-components/Button';
import Spinner from '../../../audi-ui-components/Spinner';
import Modal from '../../../audi-ui-components/Modal';

const ApplyFormModal = ({
  isActive, close,
  variant, engine, image,
  interestRate, price, term, downPayment, repayment, balloon, gfv, kmLimit,
  frequency = "WEEKLY",
  loanType,
  disclaimer, description,
  calculatorLabel = "Audi Repayment calculator",
  onEnterPostcode = ()=>{},
  onSelectDealer = ()=>{},
  onSuccess = ()=>{},
  theme
}) => {
  
  const [applyUrl, setApplyUrl] = useState(false);
  const [error, setError] = useState(false);
  
  const auiTheme = theme === "dark" ? "light" : null;
  
  const submitForm = (values, formikBag) => {
    // console.log(values);
    setError(false);
    // let interestRate = responseSummary.ComparisonRate ? responseSummary.ComparisonRate.value : responseSummary.AnnualRate.value;
    let payload = {
        vehicleData: {
            purchasePriceAmount: parseFloat(price.replace(/[^0-9.-]+/g,"")),
            model: {
                vehicleImageUrl: image,
                description: `${variant.name || variant.label} ${engine.name || engine.label}`,
                colorExterior: "White",
                colorInterior: "Black"
            }
        },
        financialProduct: {
            calculation: {
                duration: parseInt(term),
                effectiveInterestRate: interestRate / 100,
                downPaymentAmount: typeof downPayment === "string" ? parseFloat(downPayment.replace(/[^0-9.-]+/g,"")) : downPayment,
                subsequentInstallmentAmount: {
                  amount: typeof repayment === "string" ? parseFloat(repayment.replace(/[^0-9.-]+/g,"")) : repayment,
                  paymentFrequency: frequency,
                },
                loanType: loanType,
            },
            detailedName: loanType === "ConsumerLoan" ? "CONSUMER_LOAN" : "CHATTEL_MORTGAGE",
            disclaimer: btoa(unescape(encodeURIComponent("<br />" + description + "\r\n" + disclaimer)))
        },
        transaction: {localTransactionId: "1"},
        deletionPolicy: {deletionAfterDays: 5},
        dealerData: {
          companyId: values.dealer?.dealer.dealerCode,
          contactData: {
            companyName: values.dealer?.dealer.name,
            email: values.dealer?.dealer.email,
            telephoneCountryCode: "+61",
            telephoneNumber: values.dealer?.dealer.phone?.replace(/[^0-9]+/g, '')
          },
          address: {
            street: values.dealer?.address,
            houseNumber: "",
            zipCode: values.dealer?.postcode,
            city: values.dealer?.suburb,
            countryCode: "AU",
            state: values.dealer?.state,
          }
        }
    };
    if (balloon) {
        payload.financialProduct.calculation.balloonPayment = parseFloat(balloon.replace(/[^0-9.-]+/g,""));
    }
    if (gfv) {
        payload.financialProduct.calculation.guaranteedBuyBackPrice = parseFloat(gfv.replace(/[^0-9.-]+/g,""));
        payload.financialProduct.calculation.yearlyMileage = kmLimit ? parseInt(kmLimit) : 0;
        payload.financialProduct.detailedName += "_CHOICE";
    }
    console.log(payload);
    request(`${process.env.RAZZLE_API_HOST}/1/afs/onlineapplication`, {
        method: "POST",
        body: JSON.stringify(payload)
    }).then(response => {
        // console.log(response);
        onSuccess();
        formikBag.setSubmitting(false);
        let url = `${process.env.RAZZLE_AFS_APPLY}?cid=${response}`;
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
            close();
        } else {
            //Browser has blocked it
            setApplyUrl(url);
        }
    }).catch(error => {
        setError(true);
        formikBag.setSubmitting(false);
    });
  }
  
  const onClose = () => {
    setApplyUrl(false);
    setError(false);
    close();
  }
  
  return (
    <Modal isActive={isActive} modalStyle="layer" closeButton close={onClose} theme={auiTheme}>
      
      {applyUrl && <p className="py-5">We couldn't automatically redirect you. Please <a href={applyUrl} target="_blank" className="aui-textlink">click here</a> for your online finance application.</p>}
      
      {!applyUrl && isActive && <Formik onSubmit={submitForm} initialValues={{variantId: variant.id}}>
        {(formikBag) => (
          <Form className="audi-form">
            {formikBag.isSubmitting && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
            <p className="aui-headline-3 mb-5">Please select your Audi Dealer</p>
            <DealerByPostcodeModule
              title="Find your preferred or nearest Audi dealer by postcode"
              additionalDealerFields="email phone"
              additionalLocationFields="address postcode suburb state"
              onEnterPostcode={onEnterPostcode}
              onSelectDealer={onSelectDealer}
              theme={theme}
              {...formikBag}
            />
            <p className="my-3">The {calculatorLabel} is only an indication. Your selected Audi Dealer will give you a tailored Audi repayment depending on your circumstances.</p>
            {error && <p className="py-2 aui-color-text-red">An error has occured</p>}
            <p className="text-right my-3">
              <Button label="Select" type="submit" buttonType="primary" disabled={!formikBag.values.dealerId} theme={auiTheme} />
            </p>
          </Form>
        )}
      </Formik>}
    
    </Modal>
  );
}

export default ApplyFormModal;
